import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Sticker, CardHeader } from '@cordata/buffet';

import formatPhone from '~/utils/format/phone';

const ContactCard = ({
  name, telephoneNumber, officePhoneNumber, email, title, address,
}) => {
  const BodyElement = title ? CardBody : 'div';

  return (
    <Card body={!title}>
      {title && <CardHeader color="primary" inverse>{title}</CardHeader>}

      <BodyElement>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0 text-muted border border-dark rounded p-2">
            <FontAwesomeIcon icon="user" size="2x" fixedWidth />
          </div>

          <div className="flex-grow-1 ms-3 ml-3">
            <CardTitle>
              {name}

              <small className="d-block">
                {telephoneNumber && (<div><Sticker icon="phone"><a href={`tel:${telephoneNumber}`}>{formatPhone(telephoneNumber)}</a></Sticker></div>)}
                {officePhoneNumber && (<div><Sticker icon="building"><a href={`tel:${officePhoneNumber}`}>{formatPhone(officePhoneNumber)}</a></Sticker></div>)}
                {email && (<div><Sticker icon="at"><a href={`mailto:${email}`}>{email}</a></Sticker></div>)}
                {address?.address && (<div><Sticker icon="address-book">{address.address} {address.city}, {address.state} {address.zip}</Sticker></div>)}
              </small>
            </CardTitle>
          </div>
        </div>
      </BodyElement>
    </Card>
  );
};

ContactCard.propTypes = {
  name: PropTypes.string.isRequired,
  telephoneNumber: PropTypes.number,
  officePhoneNumber: PropTypes.number,
  email: PropTypes.string,
  title: PropTypes.string,
  address: PropTypes.shape(),
};

ContactCard.defaultProps = {
  telephoneNumber: undefined,
  officePhoneNumber: undefined,
  email: undefined,
  title: undefined,
  address: {},
};

export default ContactCard;
